import * as _ from 'lodash';
import { useState } from 'react';
import Validator from 'validatorjs';
import React, { useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';

import Manager from './ine/Manager';
import { FormControl } from '../../../../facturotopia';
import ComplementoIneRules from '../../support/rules/ine/ComplementoIneRules';
import TipoComiteOptions from '../../support/catalogs/complementos/ine/TipoComiteOptions';
import TipoProcesoOptions from '../../support/catalogs/complementos/ine/TipoProcesoOptions';

const rulesCallback = ComplementoIneRules;

const ComplementoINE = (props) => {

  const [data, setData] = useState({});

  const [visible, setVisible] = useState({
    Entidad: false,
    TipoComite: false,
    IdContabilidad: false,
  });

  const [validation, setValidation] = useState({
    validator: new Validator({}, rulesCallback()),
    isValid: false,
  });

  const { isValid } = validation;

  const handleOnChange = (event) => {
    const newData = {
      ...data,
      ...event,
    };

    setData(newData);
  };

  const handleOnEntidadAdd = (event) => {
    const newData = {
      ...data,
      ...event
    };

    setData(newData);
  }

  const rules = rulesCallback(data);

  const validate = (data) => {
    const validator = new Validator(data, rules);

    const newValidator = {
      validator: validator,
      isValid: validator.passes(),
    };

    setValidation(newValidator);
  };

  useEffect(() => {
    validate(data)
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleOnAdd = () => {
    let INE = {}
    let NewEntidad = [];
    const { Entidad = {} } = data;

    INE = {
      Version: '1.1',
      TipoProceso: data.TipoProceso,
      TipoComite: data.TipoComite ? data.TipoComite: undefined,
      IdContabilidad: data.IdContabilidad,
    };

    if (!_.isEmpty(Entidad)) {
      Entidad.map( (entidad) =>
        NewEntidad = [].concat(NewEntidad, [{
          ClaveEntidad: entidad.ClaveEntidad,
          Ambito: entidad.Ambito,

          Contabilidad: entidad.Contabilidad ? (
            entidad.Contabilidad.map( (item) =>
            ({
              IdContabilidad: item.IdContabilidad
            })
            )): undefined
          }]
        )
      );

      INE = {
        Version: '1.1',
        TipoProceso: data.TipoProceso,
        TipoComite: data.TipoComite ? data.TipoComite: undefined,
        IdContabilidad: data.IdContabilidad,
        Entidad: NewEntidad,
      };
    }

    props.onChange({ INE });

    setVisible({
      Entidad: false,
      TipoComite: false,
      IdContabilidad: false,
    });

    clear();
  };

  const clear = () => {
    setData({});
  };

  const handleOnCancel = () => {
    props.onCancel();
  };

  useEffect(() => {
    handleRulesApplicationOnForm();
  } ,[data]); // eslint-disable-line react-hooks/exhaustive-deps

  const ruleFormTipoProceso = () => {
    if (data.TipoProceso === '') {
      setVisible({
        ...visible,
        TipoComite: visible.TipoComite = false,
      });

      if (data.TipoComite !== '') {
        setData({
          ...data,
          TipoComite: data.TipoComite ='',
        });
      }
    }

    if (data.TipoProceso === 'Ordinario') {
      setVisible({
        ...visible,
        TipoComite: visible.TipoComite = true,
      });
    }

    if (_.isEqual(data.TipoProceso, 'Campaña') || _.isEqual(data.TipoProceso, 'Precampaña')) {
      setVisible({
        ...visible,
        Entidad: visible.Entidad = true,
        TipoComite: visible.TipoComite = false,
      });

      if (data.TipoComite !== '') {
        setData({
          ...data,
          TipoComite: data.TipoComite ='',
        });
      }
    }
  }

  const ruleFormTipoComite = () => {
    if (data.TipoComite === '') {
      setVisible({
        ...visible,
        Entidad: visible.Entidad = false,
        IdContabilidad: visible.IdContabilidad = false,
      });
    }

    if (data.TipoComite === 'Ejecutivo Nacional') {
      setVisible({
        ...visible,
        Entidad: visible.Entidad = false,
        IdContabilidad: visible.IdContabilidad = true,
      });
    }

    if (data.TipoComite === 'Ejecutivo Estatal') {
      setVisible({
        ...visible,
        Entidad: visible.Entidad = true,
        IdContabilidad: visible.IdContabilidad = false,
      });
    }

    if (data.TipoComite === 'Directivo Estatal') {
      setVisible({
        ...visible,
        Entidad: visible.Entidad = true,
        IdContabilidad: visible.IdContabilidad = true,
      });
    }
  }

  const handleRulesApplicationOnForm = () => {
    ruleFormTipoComite();
    ruleFormTipoProceso();
  }

  return (
    <>
      <div className="pb-3">
        <strong className="text-black">
          INE
        </strong>
      </div>

      <Form autoComplete="off">
        <Row>
          <Col sm md={ 4 }>
            <FormControl
              type="select"
              label="Tipo proceso"
              name="TipoProceso"
              placeholder=""
              help=""
              rules={ rules.TipoProceso }
              value={ data.TipoProceso }
              options={ TipoProcesoOptions }
              onChange={ handleOnChange }
              />
          </Col>

          <Col sm md={ 4 }>
            <FormControl
              type="select"
              label="Tipo comite"
              name="TipoComite"
              placeholder=""
              help=""
              disabled={ !visible.TipoComite }
              rules={ rules.TipoComite }
              value={ data.TipoComite }
              options={ TipoComiteOptions }
              onChange={ handleOnChange }
              />
          </Col>

          <Col sm md={ 4 }>
            <FormControl
              type="text"
              label="ID contabilidad"
              name="IdContabilidad"
              placeholder=""
              help=""
              disabled={ !visible.IdContabilidad }
              rules={ rules.IdContabilidad }
              value={ data.IdContabilidad }
              onChange={ handleOnChange }
              />
          </Col>

        </Row>
        { visible.Entidad && (
          <Manager
            ruleData={ data }
            visible={ false }
            onEntidadAdd={ handleOnEntidadAdd }
          />
        )}
        <Row>
          <Col>
            <Button
              variant="secondary"
              className="mr-2"
              onClick={ handleOnCancel }
            >
              Cancelar
            </Button>

            <Button
              variant="primary"
              disabled={ !isValid }
              onClick={ handleOnAdd }
            >
              Agregar complemento
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default ComplementoINE;
